/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Sign_In_DescriptionInputs */



/**
* | output |
* | --- |
* | "Sign in to view this artifact." |
*
* @param {Artifact_Sign_In_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_sign_in_description = /** @type {((inputs?: Artifact_Sign_In_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Sign_In_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Melden Sie sich an, um dieses Artefakt anzuzeigen.")
	return /** @type {LocalizedString} */ ("Sign in to view this artifact.")
});